import React from 'react';
import './App.css';
import CreateItem from './components/ItemPages/CreateItem';
import EditItem from './components/ItemPages/EditItem';
import ShowItems from './components/ItemPages/ShowItems';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import UserItems from './components/ItemPages/UserItems';

import ShowUsers from './components/UserPages/ShowUsers';


import Login from './components/MemberPages/Login';
import Register from './components/MemberPages/Register';
import PrivateRoute from './components/PrivateRoute'; // PrivateRoute'ı içeri aktar
import EditUser from './components/UserPages/EditUser';

function App() {
  return (
    <div className='App'>
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<Login />} />
          <Route path='/register' element={<Register />} />
          
          {/* Korunan sayfalara PrivateRoute ekliyoruz */}
          <Route 
            path='/user-items' 
            element={
              <PrivateRoute>
                <UserItems />
              </PrivateRoute>
            } 
          />
          <Route 
            path='/items' 
            element={
              <PrivateRoute>
                <ShowItems />
              </PrivateRoute>
            } 
          />
          <Route 
            path='/create' 
            element={
              <PrivateRoute>
                <CreateItem />
              </PrivateRoute>
            } 
          />
          <Route 
            path='/edit/:id' 
            element={
              <PrivateRoute>
                <EditItem />
              </PrivateRoute>
            } 
          />


          <Route 
            path='/showusers' 
            element={
              <PrivateRoute>
                <ShowUsers />
              </PrivateRoute>
            } 
          />
          <Route 
            path='/edit-user/:id' 
            element={
              <PrivateRoute>
                <EditUser />
              </PrivateRoute>
            } 
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;



/*

import React from 'react';
import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>
    </div>
  );
}

export default App;

*/